import actions from '../../actionTypes';

export default group => {
  return {
    type: actions.ADD_GROUP,
    group
  };
};



// WEBPACK FOOTER //
// ./src/reducers/groups/actions/addGroup.js